module.exports = __webpack_public_path__ + "img/15.78ce119c.png";